<template>
  <div class="tile is-parent pl-1">
    <article class="tile is-child box">
      <div style="max-height: 500px; overflow-y: auto;">
        <table class="table is-bordered is-fullwidth sticky-header-table ">
          <thead>
            <tr>
              <th style="width: 220px;"></th>
              <th style="width: 60px;">Block</th>
              <th style="width: 60px;">View</th>
              <th style="width: 60px;">Add</th>
              <th style="width: 60px;">Edit</th>
              <th style="width: 60px;">Delete</th>
              <th style="width: 60px;">Print</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="parent in parentPermissions">
              <template v-for="row in renderRows(parent, 0)">
                <PermissionRow :key="row.permission.permissionRecordID"
                  :permission="row.permission"
                  :all-permissions="value.userAccessControl"
                  :level="row.level"
                  @toggle="handleToggle" />
              </template>
            </template>
          </tbody>
        </table>
      </div>
    </article>
  </div>
</template>

<script>
import PermissionRow from './PermissionRow.vue'

export default {
  name: 'UserAccessControl',
  inject: ['$vv'],
  components: {
    PermissionRow
  },
  props: {
    value: null // v-model
  },
  computed: {
    parentPermissions() {
      return (this.value?.userAccessControl || []).filter((p) => p.parentId === '00000000-0000-0000-0000-000000000000')
    },
    $v() {
      return this.$vv ? this.$vv : this.$v
    }
  },
  mounted() {
    this.$v.userAccessControl.$touch()
  },
  methods: {
    handleToggle({ permission, type, checked }) {
      permission[type] = checked

      if (this.getChildren(permission.permissionRecordID).length > 0) {
        this.updateDescendants(permission.permissionRecordID, type, checked)
      }

      if (type === 'isBlock' && checked) {
        permission.isRead = false
        permission.isAdd = false
        permission.isEdit = false
        permission.isDelete = false
        permission.isPrint = false
        if (this.getChildren(permission.permissionRecordID).length > 0) {
          this.updateDescendants(permission.permissionRecordID, 'isBlock', true)
        }
      }

      switch (type) {
        case 'isEdit':
          permission.isRead = true
          permission.isAdd = true
          permission.isBlock = false
          break
        case 'isAdd':
        case 'isDelete':
        case 'isPrint':
          permission.isRead = true
          permission.isBlock = false
          break
        case 'isRead':
          if (!checked) {
            permission.isAdd = false
            permission.isEdit = false
            permission.isDelete = false
            permission.isPrint = false
          }
          break
        case 'isBlock':
          if (checked) {
            permission.isRead = false
            permission.isAdd = false
            permission.isEdit = false
            permission.isDelete = false
            permission.isPrint = false
          }
      }
      if (this.getChildren(permission.permissionRecordID).length > 0) {
        this.updateDescendants(permission.permissionRecordID, 'isRead', permission.isRead)
        this.updateDescendants(permission.permissionRecordID, 'isAdd', permission.isAdd)
        this.updateDescendants(permission.permissionRecordID, 'isEdit', permission.isEdit)
        this.updateDescendants(permission.permissionRecordID, 'isDelete', permission.isDelete)
        this.updateDescendants(permission.permissionRecordID, 'isPrint', permission.isPrint)
        this.updateDescendants(permission.permissionRecordID, 'isBlock', type === 'isBlock' && checked)
      }
    },
    updateDescendants(parentId, type, checked) {
      const children = this.getChildren(parentId)
      children.forEach((child) => {
        child[type] = checked

        if (type === 'isBlock' && checked) {
          child.isRead = false
          child.isAdd = false
          child.isEdit = false
          child.isDelete = false
          child.isPrint = false
        }

        this.updateDescendants(child.permissionRecordID, type, checked)
      })
    },
    getChildren(parentId) {
      return (this.value?.userAccessControl || []).filter((p) => p.parentId === parentId)
    },
    isAllChecked(parentId, permissionType) {
      const children = this.getChildren(parentId)
      return children.length > 0 && children.every((child) => child[permissionType])
    },
    toggleAll(parentId, permissionType, checked) {
      const children = this.getChildren(parentId)
      children.forEach((child) => {
        child[permissionType] = checked
      })
    },
    renderRows(permission, level) {
      const rows = [{ permission, level }]
      const children = (this.value?.userAccessControl || []).filter((p) => p.parentId === permission.permissionRecordID)
      children.forEach((child) => {
        rows.push(...this.renderRows(child, level + 1))
      })
      return rows
    }
  }
}
</script>

<style scoped>
.access-parent-row {
  background: hsl(222, 77%, 95%);
  font-weight: bold;
}

.access-parent-row.theme-dark {
  background: hsl(222, 77%, 15%);
}

.sticky-header-table th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: var(--background-color);
  color: var(--bulma-box-color);
}
</style>